export default __webpack_public_path__ + "static/media/social-yt.80d951bb.png";